module.exports = __webpack_public_path__ + "static/media/close-icon.950c3e58.svg";